import { render } from "./NachaPaymentConfList.vue?vue&type=template&id=ff226d46"
import script from "./NachaPaymentConfList.vue?vue&type=script&lang=js"
export * from "./NachaPaymentConfList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__